import { combineTokens } from '@utils/css';

const tokens = combineTokens("--table", {
  correctPercentage: "0%"
});
const statLine = "_275snenkru";
const statLineBar = "_275s14vqrvy";

export { statLine, statLineBar, tokens };
import "./stats.style.linaria.module.css";
//# sourceMappingURL=stats.style.js.map
